// extracted by mini-css-extract-plugin
export var container = "ExampleGrid-module--container--zwja1";
export var inner = "ExampleGrid-module--inner--NUWXg";
export var item = "ExampleGrid-module--item--F0OE0";
export var itemInner = "ExampleGrid-module--itemInner--5CUh0";
export var visual = "ExampleGrid-module--visual--j3bsz";